<idp-book-widget-search-modal-mach-core
  [recentSearchList]="recentSearchList"
  [savedSearchList]="savedSearchList"
  [searchModalTabs]="searchModalTabs"
  [predictiveSearchData]="predictiveSearchData"
  [isFullscreen]="isFullscreen"
  [modalOpen]="modalOpen"
  (searchModalClose)="handleSearchModalClose($event)"
  (selectedTabChange)="handleModalEvents({ type: 'tabChange', data: $event })"
  (searchStringChanged)="
    handleModalEvents({ type: 'searchStringChanged', data: $event })
  "
  (savedSearchItemSelected)="
    handleModalEvents({ type: 'saveSearchItemSelected', data: $event })
  "
  (recentSearchItemSelected)="
    handleModalEvents({ type: 'recentSearchItemSelected', data: $event })
  "
  (predictiveSearchItemSelected)="handlePredictiveSearchItemSelection($event)"
>
  <div
    #connectionPicker
    tabindex="0"
    class="flex flex-row-reverse justify-between items-center p-[18px] h-[64px] w-full relative rounded-03 focus:outline focus:outline-2 focus:outline-[#001e3c]"
    [ngClass]="{
      'border-[1px] border-solid border-stroke-01': !errorMessage,
      'border-[2px] border-solid text-alert': errorMessage
    }"
    [idpErrorState]="!!errorMessage"
    (click)="handleSearchModalTrigger()"
    (keydown.enter)="handleSearchModalTrigger()"
  >
    <div class="flex flex-row-reverse align-center gap-[18px]">
      <img
        class="cursor-pointer"
        src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/alert-icon-help.svg"
        [attr.aria-label]="placeholder + ' ' + helpIconAriaLabel"
        role="button"
        tabindex="0"
        (click)="showConnectionAirportInfoModalHandler($event)"
        (keydown.enter)="showConnectionAirportInfoModalHandler($event)"
      />
      <img
        *ngIf="connection.connectionAirport"
        role="button"
        tabindex="0"
        class="cursor-pointer"
        src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/close.svg"
        (click)="clearConnectionAirportHandler($event)"
        (keydown.enter)="clearConnectionAirportHandler($event)"
      />
    </div>
    <div class="flex">
      <small
        *ngIf="connection.connectionAirport"
        class="text-caption-medium absolute top-[11px] left-[16px]"
        [ngClass]="{ 'text-static': !errorMessage, 'text-alert': errorMessage }"
      >
        {{ placeholder }}
      </small>
      <span
        class="text-label-md-medium text-static"
        [ngClass]="{ 'pb-[11px] pt-[31px]': connection.connectionAirport }"
        tabindex="0"
        (click)="handleSearchModalTrigger()"
        (keydown.enter)="handleSearchModalTrigger()"
      >
        {{ connection.connectionAirport || placeholder }}
      </span>
    </div>
  </div>
  <ng-container *ngIf="errorMessage">
    <span class="text-alert text-caption-medium">
      {{ errorMessage }}
    </span>
  </ng-container>
</idp-book-widget-search-modal-mach-core>
